import React from "react";
import SubItemAddEditForm from "../../../hocs/tools/addOrEdit";
import { AccountTitleAction } from "../../../actions";
import { ACCOUNT_TITLE_ACCOUNTING_HINT } from "../../../constants/otherTexts";
import { REDUCER_NAMES } from "../../../constants/reducerNames";
import { withRouter } from "react-router-dom";
import { TEAM_PERMISSIONS } from "../../../constants/teamManagement";

export default withRouter(
  SubItemAddEditForm({
    title: "سرفصل‌حساب",
    reducer_name: REDUCER_NAMES.SUB_ITEMS.ACCOUNT_TITLE,
    singleItem: "account_title",
    getList: () => AccountTitleAction.getList(),
    addItem: data => AccountTitleAction.store(data),
    editItem: (id, data) => AccountTitleAction.update(id, data),
    serial_template_accounting: {
      hint: ACCOUNT_TITLE_ACCOUNTING_HINT
    },
    description: true,
    accountingCodeInfo: ACCOUNT_TITLE_ACCOUNTING_HINT,
    changePermissionsFieldName: TEAM_PERMISSIONS(true).ACCOUNT_TITLE
  })
);
